import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminSettings = () => {
  const { getAuthHeader } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    whatsapp_number: '',
    store_name: '',
    footer_message: ''
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/settings`);
      setFormData(response.data);
    } catch (error) {
      console.error('Error loading settings:', error);
      toast.error('Erro ao carregar configurações');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.put(`${API_URL}/settings`, formData, {
        headers: getAuthHeader()
      });
      toast.success('Configurações salvas com sucesso!');
      loadSettings();
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Erro ao salvar configurações');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div>
        <h1 className="text-3xl font-bold mb-8" style={{ color: '#273e82', fontFamily: 'Manrope' }}>
          Configurações
        </h1>

        <div className="bg-white rounded-xl border border-slate-200 p-6 max-w-2xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold mb-2" style={{ color: '#273e82' }}>
                Nome da Loja
              </label>
              <input
                type="text"
                name="store_name"
                value={formData.store_name}
                onChange={handleInputChange}
                className="input-field"
                data-testid="store-name-input"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-2" style={{ color: '#273e82' }}>
                Número do WhatsApp (com DDI e DDD)
              </label>
              <input
                type="text"
                name="whatsapp_number"
                value={formData.whatsapp_number}
                onChange={handleInputChange}
                placeholder="5551999999999"
                className="input-field"
                data-testid="whatsapp-number-input"
              />
              <p className="text-sm text-slate-500 mt-2">
                Exemplo: 555432827737 (55 = Brasil, 54 = DDD, 32827737 = número)
              </p>
            </div>

            <div>
              <label className="block text-sm font-semibold mb-2" style={{ color: '#273e82' }}>
                Mensagem de Rodapé (WhatsApp)
              </label>
              <textarea
                name="footer_message"
                value={formData.footer_message}
                onChange={handleInputChange}
                rows={4}
                className="input-field resize-none"
                data-testid="footer-message-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="primary-button disabled:opacity-50"
              data-testid="save-settings-button"
            >
              {loading ? 'Salvando...' : 'Salvar Configurações'}
            </button>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;